import { render } from "./CenterForm.vue?vue&type=template&id=80113cb4&scoped=true"
import script from "./CenterForm.vue?vue&type=script&lang=js"
export * from "./CenterForm.vue?vue&type=script&lang=js"

import "./CenterForm.vue?vue&type=style&index=0&id=80113cb4&lang=scss"
import "./CenterForm.vue?vue&type=style&index=1&id=80113cb4&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80113cb4"]])

export default __exports__